import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface QuickConsentCheckForCandidateResponse extends BackendResponse {
  items: QuickConsentCheckResult[];
}
export interface QuickConsentCheckForCandidateParameters
  extends NextApiParams {}

export const quickConsentCheckForCandidate = withNextApi<
  QuickConsentCheckForCandidateResponse,
  QuickConsentCheckForCandidateParameters
>("/cvp/CvpQuickConsentCheckForCandidate");

export interface QuickConsentCheckResult {
  consentType: number;
  name: string;
  description: string;
  active: boolean;
  consented?: boolean;
}
